import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';
import { View } from 'react-native';

const Play: React.FC<CustomSVGProps> = (props) => {
    return (
        <View style={{ paddingLeft: 4 }}>
            <Svg {...getBaseSVGProps(props, 40)} fill="transparent">
                <Path
                    d="M31.2177 16.6923C33.5941 18.2755 33.5941 21.7671 31.2177 23.3503L13.1825 35.3648C10.5242 37.1357 6.9648 35.23 6.9648 32.0359L6.9648 8.00671C6.9648 4.81255 10.5242 2.90687 13.1825 4.67776L31.2177 16.6923Z"
                    fill={props.color}
                />
            </Svg>
        </View>
    );
};

export default React.memo(Play);
